/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import Typography from 'apollo-react/components/Typography';
import StatusCheck from 'apollo-react-icons/StatusCheck';
import qs from 'query-string';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import { getNextStepLink } from './utils';
import {
  setOpenDetailFormTabEntityDisplay,
  setOpenStepFormTabEntityDisplay,
} from '../../actions/EntityDisplayActions';
import * as Urls from '../../constants/Urls';
import { clearFormDesigner } from '../../form-designer/actions/form-manager.actions';
import { FORM_KEYS } from '../../form-designer/constants/form-manager.constants';
import { clearValidationStorage } from '../../form-designer/utils/validationStorage.utils';
import { getUITA } from '../../utils/commonUtils';

const SIGN_OFF_SUBMIT_MESSAGE = 'Record Submitted';
const SAVE_OR_CREATE_SUBMIT_MESSAGE = 'Save Successful!';

const useStyles = makeStyles({
  signOffCompletedPaperFullWidth: {
    margin: 0,
    alignItems: 'center',
    width: '100%',
    maxWidth: '100%',
    minHeight: 300,
    bottom: 0,
    position: 'absolute',
    backgroundColor: '#0768fd !important',
    border: 'none !important',
    borderRadius: '0 !important',
    color: '#f8f9fb',
    paddingBottom: 15,

    '& > div:first-child': {
      display: 'none',
    },
  },
  nextStepLink: {
    cursor: 'pointer',
    color: 'white',
    textDecoration: 'none',
    display: 'inline-block',
  },
  signOffDialog: {
    textAlign: 'center',
    width: '100%',
  },
  submitMessageContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '160px',
    marginBottom: 10,
  },
  submitMessageIcon: {
    width: '42px',
    height: '42px',
  },
  submitMessageText: {
    paddingTop: '10px',
    fontSize: '18px',
    color: '#fff',
  },
});

const SubmitCompleted = ({
  open,
  submitWorkflowApiCompleted,
  submitWorkflowResult,
  workFlowSteps,
  hasErrors,
  translatedEntityNames,
  latestSubmitType,
  handleDialogClose,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const entities = submitWorkflowResult?.entities ?? [];
  const goToDashboard = submitWorkflowResult?.goToDashboardMessage || 'Go to Dashboard';

  const handleGoToDashboard = () => {
    history.push(Urls.HOME);
    handleDialogClose();
  };

  const getGoToMessage = (entity, idx) => {
    const goToDetailMessage = entity?.goToDetailMessage;
    const translatedEntityName = entity?.translatedEntityName ?? translatedEntityNames[idx];
    const entityName = entity?.entityName;
    return goToDetailMessage || `Go to ${translatedEntityName || entityName} Detail`;
  };

  const getSubmitMessage = () => {
    const {
      saveOrCreateSubmittedMessage = SAVE_OR_CREATE_SUBMIT_MESSAGE,
      signOffSubmittedMessage = SIGN_OFF_SUBMIT_MESSAGE,
    } = submitWorkflowResult || {};

    return latestSubmitType === 'sign-off' ||
      latestSubmitType === 'bulk-upload' ||
      latestSubmitType === 'batch-submit'
      ? signOffSubmittedMessage
      : saveOrCreateSubmittedMessage;
  };

  const handleLinkClick = (isDetail = false) => {
    handleDialogClose();
    clearValidationStorage();
    dispatch(clearFormDesigner(FORM_KEYS.STEP));

    if (isDetail) {
      dispatch(setOpenDetailFormTabEntityDisplay(true));
    } else {
      dispatch(setOpenStepFormTabEntityDisplay(true));
    }

    window.scrollTo(0, 0);
  };

  return (
    <Modal
      open={open}
      fullWidth
      classes={{ paperFullWidth: classes.signOffCompletedPaperFullWidth }}
      onClose={handleDialogClose}
      hideButtons
      disableBackdropClick
      disableEscapeKeyDown
      title=""
    >
      <div className={classes.signOffDialog} ui-ta={getUITA('NavigationNextSteps')}>
        <div>
          {submitWorkflowApiCompleted && !hasErrors ? (
            <div className={classes.submitMessageContainer}>
              <StatusCheck className={classes.submitMessageIcon} />
              <Typography ui-ta="workflow-summary-message" className={classes.submitMessageText}>
                {getSubmitMessage()}
              </Typography>
            </div>
          ) : (
            <div className={classes.submitMessageContainer} />
          )}
        </div>
        {entities.map((entity, idx) => (
          <div key={entity.itmId}>
            <Link
              className={classes.nextStepLink}
              ui-ta={getUITA('NavigationNextStep', 'Detail')}
              to={getNextStepLink(entity)}
              onClick={() => handleLinkClick(true)}
            >
              {getGoToMessage(entity, idx)}
            </Link>
          </div>
        ))}
        <div
          ui-ta={getUITA('NavigationNextStep', 'Dashboard')}
          className={classes.nextStepLink}
          key="dashboard"
          onClick={handleGoToDashboard}
        >
          <span>{goToDashboard}</span>
        </div>
        {!hasErrors
          ? workFlowSteps.map((step, index) => {
              return (
                <span ui-ta={getUITA('NavigationNextStep')} key={index}>
                  <div>
                    <Link
                      className={classes.nextStepLink}
                      to={{
                        pathname: Urls.ENTITY_DISPLAY,
                        search: qs.stringify({
                          itmId: step.itmId,
                          entityType: step.entityType,
                          workflowId: step.workflowId,
                          stepId: step.stepId,
                          formKey: step.formKey,
                        }),
                      }}
                      onClick={() => handleLinkClick(false)}
                    >
                      {step.translatedStepName}
                    </Link>
                  </div>
                </span>
              );
            })
          : ''}
      </div>
    </Modal>
  );
};

export default SubmitCompleted;
